import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import {
  Button, Col, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { FILE_FORMAT_LIST } from '../../../configs';
import MultipleSelectInput from '../../../components/fields/SelectInput/MultipleSelectInput';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';

export default function ExportDialog(props) {
  const {
    onClose, handleExport, columns = [],
  } = props;
  const [type, setType] = React.useState(FILE_FORMAT_LIST[0].value);
  const [selectedColumns, setSelectedColumns] = React.useState(columns.map(x => x.dataField));
  const { formatMessage } = useIntl();

  return (
    <Dialog
      onClose={() => { onClose(); }}
      size="none"
      open
    >
      <DialogTitle
        header="Экспорт зон"
        title={<Icons width={14} height={14} customIcon icon="clear" className="pointer" onClick={onClose} />}
      />
      <DialogContent>
        <Row>
          <Col columns={12}>
            <CustomSelectInput
              type="text"
              component={MultipleSelectInput}
              withLabel
              variant="material"
              label="Столбцы для экспорта"
              multiple
              inputProps={{
                value: selectedColumns,
                onChange: e => setSelectedColumns(e.target.value),
              }}
              options={columns.map((item, index) => ({
                name: formatMessage({
                  id: item.text || item.dataField,
                  defaultMessage: item.text || ' ',
                }),
                value: item.dataField,
              }))}
            />
          </Col>
        </Row>
        <div className="f4 mt-3">Выберите формат документа для экспорта</div>
        <Row>
          <div className="ual-popup-box-buttons">
            {
              FILE_FORMAT_LIST.map((item, key) => (
                <Button
                  className={classNames('me-3 px-3', { active: item.value === type })}
                  key={key}
                  variant="link"
                  onClick={() => setType(item.value)}
                >{formatMessage({ id: `file.format.${item.value}` })}
                </Button>
              ))
            }
          </div>
        </Row>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <Button variant="secondary" onClick={() => { onClose(); }}>Отменить</Button>
        <Button onClick={() => { onClose(); handleExport(type, selectedColumns); }}>Экспортировать</Button>
      </DialogFooter>
    </Dialog>
  );
}
